export default __webpack_public_path__ + "static/media/background.8da54e57.svg";